import React, { useContext, useEffect} from "react";

import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppRoutes } from "../../../routes";
import UserContext from "../../../utils/context/user/userContext";
import { lastSolutionsRequest, passcodeRequest } from "../../../utils/request/api";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const Presentation = () => {

  const navigate = useNavigate();
  const userContext = useContext(UserContext);

  const [searchParams] = useSearchParams();

  const checkPasscode = async e => {
    const pc = searchParams.get("pc");
    if(pc) {
      const data = await passcodeRequest(pc);
      if (data.user){
        localStorage.setItem("hideProfile", "true");
        data.user.hideProfile = true;
        userContext.handleUserLogin(data);
        navigate(AppRoutes.DashboardOverview.path);
      }
    }
  };

  useEffect(() => {
    checkPasscode()
    async function lastData(){
      let logins;
      if(userContext.isAuth === true){
        if(userContext.user?.id && userContext.user?.lastProfile){
          logins = await lastSolutionsRequest(userContext.user?.id, userContext.user?.lastProfile)
          if(logins.res?.data.length && logins.res?.data[0].solutionType !== "LEAD_GENERATION"){
            navigate(AppRoutes.Dashboards_template.path + logins.res.data[0].solutionCode)
          }else{
            navigate(AppRoutes.DashboardOverview.path);
          }
        }else{
          navigate(AppRoutes.DashboardOverview.path);
        }
      }else{
        navigate(AppRoutes.Signin.path);
      }
    }

    lastData();
  })

  return (
    <LoadingScreen />
  );
};

export default Presentation;